import type { IGasPriceToPreview } from 'src/interfaces/gas-price.model';

export function usePriceType(gasPrice: IGasPriceToPreview, localizedMessage: (key: string) => string) {
  const isGasPriceOneType = gasPrice.count != null && gasPrice.count === 1;

  if (isGasPriceOneType) {
    return localizedMessage('calculator__speed-average');
  }

  return gasPrice.type === 'normal' ? 'optimal' : gasPrice.type;
}
